export const styles = ({ palette }) => ({
  categoryName: {
    fontWeight: 500,
  },
  rootNode: {
    textTransform: 'uppercase',
    '&.rollup': {
      background: palette.action.selected,
      width: 'inherit',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 5,
    },
  },
});
